import React from 'react';

import styled from 'styled-components';
import { Button } from 'styles/admin';
import { ColoredCircularProgress, StyledTypography } from 'styles/common';

const Container = styled.div`
  background: white;
  border: 1px solid #eaeaea;
  padding: 1rem 1.5rem;
  position: fixed;
  left: 19%;
  width: calc(80% - 3rem + 2px);
  bottom: 0;
  margin: 0 2.25em 0 2.25em;
  text-align: right;
  button {
    padding: 0.5rem 2.5rem;
  }
`;

const ButtonSpacer = styled.div`
  display: inline-block;
  width: 2%;
`;

const ActionsContainer = ({
  onBackClick,
  onNextClick,
  backText = 'back',
  nextText = 'next',
  nextDisabled,
  loading,
  isDraft,
  creatingText = 'creating',
  ContainerComp = null,
}) => {
  const SelectedContainerComp = ContainerComp ?? Container;

  return (
    <SelectedContainerComp>
      <Button blueOutline onClick={onBackClick} disabled={loading || !onBackClick}>
        <StyledTypography weight={600} variant="body" texttransform="capitalize">
          {backText}
        </StyledTypography>
      </Button>
      <ButtonSpacer />
      <Button
        startIcon={loading && isDraft ? <ColoredCircularProgress color="white" size="tinier" /> : null}
        blue
        onClick={onNextClick}
        disabled={loading || nextDisabled || !onNextClick}
      >
        <StyledTypography weight={600} variant="body" texttransform="capitalize" color="white">
          {loading && isDraft ? creatingText : nextText}
        </StyledTypography>
      </Button>
    </SelectedContainerComp>
  );
};

export default ActionsContainer;
